{
  "endTime": "終了時刻",
  "startTime": "開始時刻",
  "time": "時刻"
}
